export default "__VITE_ASSET__9019a6df__"